import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Alert, Box, Button, TextField } from "@mui/material";
import { MenuInicial } from "./MenuInicial";
import { Save as SaveIcon } from '@mui/icons-material';
import { API_BASE_URL, USERACTUALIZAR } from '../services/apiConfig';
import { isAuthenticated } from '../services/api';
import axios from "axios";
import './estilos.css';
function User() {
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const username = userData?.username;
  const usuarioid = userData?.usuarioid;
  const [apiResponse, setApiResponse] = useState("");
  const [showDiv, setShowDiv] = useState(false);
  const segundosAMostrar = 2; // Cambia esto al valor deseado
  const timeoutId = setTimeout(() => {
    setShowDiv(false);
  }, segundosAMostrar * 1000);
  
  useEffect(() => {
    const autenticado = isAuthenticated();
    if (autenticado===false) {
      navigate("/login");
    }



    return () => {
      // Limpia el temporizador si el componente se desmonta antes de que se oculte el div
      clearTimeout(timeoutId);
    };
  }, [navigate]);

    
  const [name, setName] = useState(username); // Estado para el nombre del usuario

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Realiza una solicitud a la API para actualizar el nombre del usuario
    try {

      axios
      .post( API_BASE_URL + USERACTUALIZAR , {
        username: name,
        usuarioid: usuarioid,
        
      })
      .then((response) => {
        console.log(response);
        setApiResponse(response.data.message);
        setShowDiv(true);
        clearTimeout(timeoutId);
        
      })
      .catch((error) => {
        console.error(error);
        setApiResponse(error.response.data.message);
      });
    } catch (error) {
      console.error('Error de red:', error);
    }
  };

  return (
    <div >
   <Container>
      <MenuInicial></MenuInicial>
      </Container>
      
      <Container maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <TextField
          label="Nombre"
          variant="outlined"
          fullWidth
          value={name}
          onChange={handleNameChange}
        />
          <div className="miDivSep" >
        <Button
          type="submit"
          variant="contained"
          color="primary"
          startIcon={<SaveIcon />}
        >
          Actualizar
        </Button></div>
      </form>
    </Container>

 
    {showDiv && (
          <div className="miDivMed" >   <p><Alert severity="success"> actualizado correctamente </Alert></p> </div>
      )}

    </div>
  );
}

export default User;
